import {observer} from "mobx-react";
import React from "react";
import {useBetween} from "use-between";
import {
    useModalSearchResponseStandard
} from "@dropDesk/presentation/pages/response_standard/modals/handle_change_visible";
import {
    ContainerModalNewResponseStander,
    ContentModalNewResponseStander
} from "./styled";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import FooterModal from "@dropDesk/presentation/components/footer/footer_modal";
import InputsFormResponseStandard from "@dropDesk/presentation/pages/response_standard/modals/modal_crud/inputs";
import {
    useValidatorInputResponseStandard
} from "@dropDesk/presentation/pages/response_standard/modals/modal_crud/inputs/validator";
import {ResponseStandardEntity} from "@dropDesk/domain/entities/response_standard/response_standard.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import toastMessage from "@dropDesk/utils/toast_message/toast_message";
import {useTranslation} from "react-i18next";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";


const ModalCrudResponseStandard = observer(
    ({
         responseStandard,
         onUpdate,
         loading,
         handleVisibleModalNewResponseStandard,
         set
     }: {
        responseStandard?: ResponseStandardEntity
        onUpdate: (responseStandard: ResponseStandardEntity) => void,
        loading: boolean,
        handleVisibleModalNewResponseStandard: (visible: boolean, id: string) => void,
        set: (onSuccess: (key: string) => void) => Promise<void>
    }) => {
        const {t} = useTranslation();
        const {validate} = useValidatorInputResponseStandard(responseStandard, loading);

        const handleSubmit = async () => {
            if (validate()) {
                await set(onSuccessSave);
            }
        }

        const onSuccessSave = (key: string) => {
            toastMessage.success(t(key));
            handleVisibleModalNewResponseStandard(false, isNewRegister)
        }

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const isNewRegister = 'new';

        const {
            visibleModalNewResponseStandard,
        } = useBetween(useModalSearchResponseStandard);

        const {
            errorMessageTitle,
            errorMessageDescription,
        } = useValidatorInputResponseStandard(responseStandard, loading);

        return (
            <ModalMain
                open={visibleModalNewResponseStandard}
                onRequestClose={() => handleVisibleModalNewResponseStandard(false, isNewRegister)}
                width={500}
                renderComponent={
                    <ContainerModalNewResponseStander background={colors.onBackground}>
                        <HeaderModal
                            disabled={loading}
                            letter={responseStandard?.isUnsaved() ? 'Cadastro de respostas rápidas' : 'Editando respostas rápidas'}
                            nameIcon={ICONS_DROPDESK.close}
                            onClick={() => handleVisibleModalNewResponseStandard(false, isNewRegister)}
                        />
                        <ContentModalNewResponseStander>
                            <InputsFormResponseStandard
                                responseStandard={responseStandard}
                                onUpdate={onUpdate}
                                loading={loading}
                            />
                        </ContentModalNewResponseStander>
                        <FooterModal
                            disabled={loading || !!errorMessageTitle || !!errorMessageDescription}
                            loading={loading}
                            type={"submit"}
                            letter={'Salvar'}
                            onSubmit={handleSubmit}
                            onRequestClose={() => handleVisibleModalNewResponseStandard(false, isNewRegister)}
                            createdAt={responseStandard?.createdAt ? `Criado em ${displayDateToLocale(responseStandard.createdAt)}` : undefined}
                        />
                    </ContainerModalNewResponseStander>}
            />
        )
    })
export default ModalCrudResponseStandard;
